<template>
  <div class="todo-list-container">
    <div class="todo-card">
      <!-- 输入区域 -->
      <div class="todo-input-section">
        <textarea
          class="todo-input"
          :placeholder="placeholder"
          v-model="newTaskText"
          @keydown="handleKeyPress"
          rows="2"
        ></textarea>
        <button class="todo-add-btn" @click="addTask">
          <span>{{ addButtonText }}</span>
        </button>
      </div>

      <!-- 筛选栏 -->
      <div class="todo-filter-bar">
        <div class="todo-summary">
          <span class="summary-count">{{ totalTasks }}</span>
          <span class="summary-text">项</span>
          <span class="summary-divider">·</span>
          <span class="summary-text">已完成</span>
          <span class="summary-count completed-count">{{ completedTasks }}</span>
          <span class="summary-text">项</span>
        </div>
        <!-- <div class="filter-tabs">
          <span
            v-for="tab in filterTabs"
            :key="tab.key"
            class="filter-tab"
            :class="{ active: currentFilter === tab.key }"
            @click="setFilter(tab.key)"
          >
            {{ tab.label }}
          </span>
        </div> -->
      </div>

      <!-- 任务列表 -->
      <div class="todo-list">
        <div
          v-for="task in filteredTodos"
          :key="task.id"
          class="todo-item"
          :class="{ completed: task.completed }"
        >
          <div class="todo-item-content">
            <span class="todo-text" :title="task.text">{{ task.text }}</span>
            <div class="todo-meta">
              <span class="todo-time">{{ formatDate(task.createdAt) }}</span>
              <span v-if="task.completed" class="todo-status completed-status">已完成</span>
              <span v-else class="todo-status pending-status">进行中</span>
            </div>
          </div>
          <div class="todo-item-right">
            <!-- 编辑按钮 -->
            <a class="todo-edit" title="编辑" @click="startEdit(task)">
              <svg class="edit-icon-svg" viewBox="0 0 24 24" fill="none">
                <path
                  d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            <!-- 开关组件 -->
            <label class="todo-switch">
              <input type="checkbox" :checked="task.completed" @change="toggleTask(task)" />
              <span class="switch-slider">
                <span v-if="task.completed" class="switch-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17L4 12"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </span>
            </label>
            <!-- 删除按钮 - 带确认提示 -->
            <el-popconfirm
              title="确定删除这项吗？"
              confirm-button-text="确定"
              cancel-button-text="取消"
              @confirm="deleteTask(task)"
            >
              <a slot="reference" class="todo-delete" title="删除">
                <svg class="delete-icon-svg" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </a>
            </el-popconfirm>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="filteredTodos.length === 0" class="todo-empty">
          <svg class="empty-icon" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M9 12H15M9 16H15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <span class="empty-text">暂无待办事项</span>
        </div>
      </div>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑待办事项"
      :visible.sync="editDialogVisible"
      width="500px"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      append-to-body
    >
      <el-input
        v-model="editText"
        type="textarea"
        :rows="4"
        placeholder="请输入待办事项内容"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'todo-list',
  props: {
    title: {
      type: String,
      default: 'Todo List'
    },
    subtitle: {
      type: String,
      default: '单页应用'
    },
    placeholder: {
      type: String,
      default: '输入待办事项，按 Ctrl+Enter 或点击添加...'
    },
    addButtonText: {
      type: String,
      default: '+ 添加'
    },
    showDate: {
      type: Boolean,
      default: true
    },
    // 支持通过 v-model 传入的待办事项
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentFilter: 'all',
      newTaskText: '',
      filterTabs: [
        { key: 'all', label: '全部' },
        { key: 'pending', label: '未完成' },
        { key: 'completed', label: '已完成' }
      ],
      editDialogVisible: false,
      editingTask: null,
      editText: ''
    }
  },
  computed: {
    todos() {
      return this.value || []
    },
    filteredTodos() {
      switch (this.currentFilter) {
        case 'pending':
          return this.todos.filter(t => !t.completed)
        case 'completed':
          return this.todos.filter(t => t.completed)
        default:
          return this.todos
      }
    },
    totalTasks() {
      return this.todos.length
    },
    completedTasks() {
      return this.todos.filter(t => t.completed).length
    }
  },
  methods: {
    addTask() {
      const text = this.newTaskText.trim()
      if (!text) return

      const newTask = {
        id: this.generateId(),
        text: text,
        completed: false,
        createdAt: new Date().getTime()
      }

      const newTodos = [newTask, ...this.todos]
      this.$emit('input', newTodos)
      this.$emit('change', newTodos)
      this.$emit('todo-change', newTodos)
      this.newTaskText = ''
    },
    handleKeyPress(event) {
      // Ctrl+Enter 或 Cmd+Enter 提交任务
      if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        this.addTask()
      }
    },
    toggleTask(task) {
      const newTodos = this.todos.map(t => {
        if (t.id === task.id) {
          return { ...t, completed: !t.completed }
        }
        return t
      })
      this.$emit('input', newTodos)
      this.$emit('change', newTodos)
      this.$emit('todo-change', newTodos)
      this.$emit('task-click', task)
    },
    deleteTask(task) {
      const newTodos = this.todos.filter(t => t.id !== task.id)
      this.$emit('input', newTodos)
      this.$emit('change', newTodos)
      this.$emit('todo-change', newTodos)
      this.$emit('task-delete', task)
    },
    setFilter(filterType) {
      this.currentFilter = filterType
    },
    formatDate(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}/${month}/${day}`
    },
    generateId() {
      return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    },
    // 开始编辑
    startEdit(task) {
      this.editingTask = task
      this.editText = task.text
      this.editDialogVisible = true
    },
    // 保存编辑
    saveEdit() {
      if (!this.editText.trim()) {
        this.$message.warning('待办事项内容不能为空')
        return
      }
      const newTodos = this.todos.map(t => {
        if (t.id === this.editingTask.id) {
          return { ...t, text: this.editText.trim() }
        }
        return t
      })
      this.$emit('input', newTodos)
      this.$emit('change', newTodos)
      this.$emit('todo-change', newTodos)
      this.cancelEdit()
    },
    // 取消编辑
    cancelEdit() {
      this.editDialogVisible = false
      this.editingTask = null
      this.editText = ''
    }
  }
}
</script>

<style scoped src="./main.css"></style>



// WEBPACK FOOTER //
// src/components/todo-list/main.vue